
import {Component, EventEmitter, Input, OnInit, OnDestroy, Output, ViewChildren, QueryList} from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import {Subscription as RxJsSubscription} from 'rxjs';
import {ErrorService, ExplainErrorsService, SessionService} from '@app/services';
import { environment } from '@env/environment';
import {Gallery} from '../gallery';
import {GalleryService} from '../gallery.service';
import { LanguageTabComponent } from '@app/models/language';
@Component({
  selector: 'hpf-gallery-form',
  templateUrl: './gallery-form.component.html'
})
export class GalleryFormComponent implements OnInit, OnDestroy {
  /** The model subscription */
  private modelSubscription: RxJsSubscription;
  /** The gallery to inject in the form */
  @Input() gallery: Gallery;
  /** Called the save button is clicked for a new instance */
  @Output() create = new EventEmitter<Gallery>();
  /** Called the save button is clicked for an existing instance */
  @Output() update = new EventEmitter<void>();
  /** Called the delete button is clicked */
  @Output() delete = new EventEmitter<void>();
  /** Set loading state of the form */
  @Input() loading = false;
  /** Enable the deletion button */
  @Input() deletable = true;
	/** Enabled quick form */
	@Input() quickFormEnabled = environment.plugins.quickForm.enabled;
  /** Denotes if deltion in progress */
  deleting = false;
  /** Show delete modal */
  deleteModal = false;
  /** The form group to use */
  form: FormGroup;
  /** Denotes if the form is pending */
  saving = false;
  /** Check permission of update **/
  readOnly = false;
	@ViewChildren(LanguageTabComponent) languageTabs: QueryList<
		LanguageTabComponent
	>;
  /** Constructor */
  constructor(private formBuilder: FormBuilder,
              private errorService: ErrorService,
              public explainErrorsService: ExplainErrorsService,
              private galleryService: GalleryService,
              private sessionService: SessionService) {
  }
  /** Init */
  async ngOnInit() {
    this.readOnly = !(await this.sessionService.checkPermission(
			'gallery',
			'update'
		));

    // Init model
    if(!this.gallery) this.gallery = new Gallery();

    // Create form
    this.form = this.formBuilder.group({
    name: new FormControl(this.gallery.props.name, [Validators.required]),
    images: new FormControl(this.gallery.props.images, [Validators.required]),

    });
    // Update form when model loads or changes
    this.modelSubscription = this.gallery.subscribe(() => {
        this.updateForm();
    });
  }
  /** Destroy */
  ngOnDestroy() {
    this.modelSubscription.unsubscribe();
  }
  /** Called on form submit */
  async onSubmit(): Promise<void> {
    // Saving flag
    this.saving = true;
    try {
        // Update model
        this.updateModel();
		for (let element of this.languageTabs) {
				await element.submit();
			}
        // Creation or update ?
        if (this.gallery.isNew()) {
            // Creation
            const gallery: Gallery = await this.galleryService.create(this.gallery.toPayload());
            this.create.next(gallery);
        } else {
            // Update
            await this.galleryService.update(this.gallery.getId(), this.gallery.toPayload());
            this.update.next();
        }
    } catch (error) {
        this.errorService.handle(error);
    }
    // Saving flag
    this.saving = false
  }
  /** Update models properties from inputs values */
  private updateModel(): void {
    for (const key of Object.keys(this.form.controls)) {
        this.gallery.props[key] = this.form.get(key).value;
    }
  }
  /** Update inputs values from models properties */
  private updateForm(): void {
    this.form.setValue({
      'name': this.gallery.props.name,   
      'images': this.gallery.props.images,   

    });
  }
  /** Called on deletion */
  onDelete(): void {
    this.deleting = true;
    this.galleryService.remove(this.gallery.getId())
      .then(() => {
        this.delete.next();
      })
      .catch((error) => this.errorService.handle(error))
      .then(() => this.deleting = false);
  }
}
